import { Connection as $ } from "./connection.js";
var w = function(e, t) {
  return w = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, w(e, t);
};
function h(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  w(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
function g(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function E(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    s = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function O(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function p(e) {
  return typeof e == "function";
}
function C(e) {
  var t = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, r = e(t);
  return r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r;
}
var S = C(function(e) {
  return function(r) {
    e(this), this.message = r ? r.length + ` errors occurred during unsubscription:
` + r.map(function(n, i) {
      return i + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = r;
  };
});
function x(e, t) {
  if (e) {
    var r = e.indexOf(t);
    0 <= r && e.splice(r, 1);
  }
}
var m = (function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, r, n, i, o;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var u = g(s), c = u.next(); !c.done; c = u.next()) {
              var a = c.value;
              a.remove(this);
            }
          } catch (l) {
            t = { error: l };
          } finally {
            try {
              c && !c.done && (r = u.return) && r.call(u);
            } finally {
              if (t) throw t.error;
            }
          }
        else
          s.remove(this);
      var f = this.initialTeardown;
      if (p(f))
        try {
          f();
        } catch (l) {
          o = l instanceof S ? l.errors : [l];
        }
      var A = this._finalizers;
      if (A) {
        this._finalizers = null;
        try {
          for (var d = g(A), v = d.next(); !v.done; v = d.next()) {
            var Y = v.value;
            try {
              I(Y);
            } catch (l) {
              o = o ?? [], l instanceof S ? o = O(O([], E(o)), E(l.errors)) : o.push(l);
            }
          }
        } catch (l) {
          n = { error: l };
        } finally {
          try {
            v && !v.done && (i = d.return) && i.call(d);
          } finally {
            if (n) throw n.error;
          }
        }
      }
      if (o)
        throw new S(o);
    }
  }, e.prototype.add = function(t) {
    var r;
    if (t && t !== this)
      if (this.closed)
        I(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (r = this._finalizers) !== null && r !== void 0 ? r : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var r = this._parentage;
    return r === t || Array.isArray(r) && r.includes(t);
  }, e.prototype._addParent = function(t) {
    var r = this._parentage;
    this._parentage = Array.isArray(r) ? (r.push(t), r) : r ? [r, t] : t;
  }, e.prototype._removeParent = function(t) {
    var r = this._parentage;
    r === t ? this._parentage = null : Array.isArray(r) && x(r, t);
  }, e.prototype.remove = function(t) {
    var r = this._finalizers;
    r && x(r, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = (function() {
    var t = new e();
    return t.closed = !0, t;
  })(), e;
})(), F = m.EMPTY;
function B(e) {
  return e instanceof m || e && "closed" in e && p(e.remove) && p(e.add) && p(e.unsubscribe);
}
function I(e) {
  p(e) ? e() : e.unsubscribe();
}
var J = {
  Promise: void 0
}, D = {
  setTimeout: function(e, t) {
    for (var r = [], n = 2; n < arguments.length; n++)
      r[n - 2] = arguments[n];
    return setTimeout.apply(void 0, O([e, t], E(r)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function H(e) {
  D.setTimeout(function() {
    throw e;
  });
}
function U() {
}
function _(e) {
  e();
}
var j = (function(e) {
  h(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n.isStopped = !1, r ? (n.destination = r, B(r) && r.add(n)) : n.destination = q, n;
  }
  return t.create = function(r, n, i) {
    return new P(r, n, i);
  }, t.prototype.next = function(r) {
    this.isStopped || this._next(r);
  }, t.prototype.error = function(r) {
    this.isStopped || (this.isStopped = !0, this._error(r));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(r) {
    this.destination.next(r);
  }, t.prototype._error = function(r) {
    try {
      this.destination.error(r);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
})(m), L = (function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var r = this.partialObserver;
    if (r.next)
      try {
        r.next(t);
      } catch (n) {
        y(n);
      }
  }, e.prototype.error = function(t) {
    var r = this.partialObserver;
    if (r.error)
      try {
        r.error(t);
      } catch (n) {
        y(n);
      }
    else
      y(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (r) {
        y(r);
      }
  }, e;
})(), P = (function(e) {
  h(t, e);
  function t(r, n, i) {
    var o = e.call(this) || this, s;
    return p(r) || !r ? s = {
      next: r ?? void 0,
      error: n ?? void 0,
      complete: i ?? void 0
    } : s = r, o.destination = new L(s), o;
  }
  return t;
})(j);
function y(e) {
  H(e);
}
function V(e) {
  throw e;
}
var q = {
  closed: !0,
  next: U,
  error: V,
  complete: U
}, G = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})();
function K(e) {
  return e;
}
function Q(e) {
  return e.length === 0 ? K : e.length === 1 ? e[0] : function(r) {
    return e.reduce(function(n, i) {
      return i(n);
    }, r);
  };
}
var k = (function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var r = new e();
    return r.source = this, r.operator = t, r;
  }, e.prototype.subscribe = function(t, r, n) {
    var i = this, o = Z(t) ? t : new P(t, r, n);
    return _(function() {
      var s = i, u = s.operator, c = s.source;
      o.add(u ? u.call(o, c) : c ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (r) {
      t.error(r);
    }
  }, e.prototype.forEach = function(t, r) {
    var n = this;
    return r = M(r), new r(function(i, o) {
      var s = new P({
        next: function(u) {
          try {
            t(u);
          } catch (c) {
            o(c), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      n.subscribe(s);
    });
  }, e.prototype._subscribe = function(t) {
    var r;
    return (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(t);
  }, e.prototype[G] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return Q(t)(this);
  }, e.prototype.toPromise = function(t) {
    var r = this;
    return t = M(t), new t(function(n, i) {
      var o;
      r.subscribe(function(s) {
        return o = s;
      }, function(s) {
        return i(s);
      }, function() {
        return n(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
})();
function M(e) {
  var t;
  return (t = e ?? J.Promise) !== null && t !== void 0 ? t : Promise;
}
function X(e) {
  return e && p(e.next) && p(e.error) && p(e.complete);
}
function Z(e) {
  return e && e instanceof j || X(e) && B(e);
}
function N(e) {
  return p(e?.lift);
}
function rr(e) {
  return function(t) {
    if (N(t))
      return t.lift(function(r) {
        try {
          return e(r, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function tr(e, t, r, n, i) {
  return new er(e, t, r, n, i);
}
var er = (function(e) {
  h(t, e);
  function t(r, n, i, o, s, u) {
    var c = e.call(this, r) || this;
    return c.onFinalize = s, c.shouldUnsubscribe = u, c._next = n ? function(a) {
      try {
        n(a);
      } catch (f) {
        r.error(f);
      }
    } : e.prototype._next, c._error = o ? function(a) {
      try {
        o(a);
      } catch (f) {
        r.error(f);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, c._complete = i ? function() {
      try {
        i();
      } catch (a) {
        r.error(a);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, c;
  }
  return t.prototype.unsubscribe = function() {
    var r;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      e.prototype.unsubscribe.call(this), !n && ((r = this.onFinalize) === null || r === void 0 || r.call(this));
    }
  }, t;
})(j), nr = C(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), R = (function(e) {
  h(t, e);
  function t() {
    var r = e.call(this) || this;
    return r.closed = !1, r.currentObservers = null, r.observers = [], r.isStopped = !1, r.hasError = !1, r.thrownError = null, r;
  }
  return t.prototype.lift = function(r) {
    var n = new W(this, this);
    return n.operator = r, n;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new nr();
  }, t.prototype.next = function(r) {
    var n = this;
    _(function() {
      var i, o;
      if (n._throwIfClosed(), !n.isStopped) {
        n.currentObservers || (n.currentObservers = Array.from(n.observers));
        try {
          for (var s = g(n.currentObservers), u = s.next(); !u.done; u = s.next()) {
            var c = u.value;
            c.next(r);
          }
        } catch (a) {
          i = { error: a };
        } finally {
          try {
            u && !u.done && (o = s.return) && o.call(s);
          } finally {
            if (i) throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(r) {
    var n = this;
    _(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.hasError = n.isStopped = !0, n.thrownError = r;
        for (var i = n.observers; i.length; )
          i.shift().error(r);
      }
    });
  }, t.prototype.complete = function() {
    var r = this;
    _(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.isStopped = !0;
        for (var n = r.observers; n.length; )
          n.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var r;
      return ((r = this.observers) === null || r === void 0 ? void 0 : r.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(r) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, r);
  }, t.prototype._subscribe = function(r) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(r), this._innerSubscribe(r);
  }, t.prototype._innerSubscribe = function(r) {
    var n = this, i = this, o = i.hasError, s = i.isStopped, u = i.observers;
    return o || s ? F : (this.currentObservers = null, u.push(r), new m(function() {
      n.currentObservers = null, x(u, r);
    }));
  }, t.prototype._checkFinalizedStatuses = function(r) {
    var n = this, i = n.hasError, o = n.thrownError, s = n.isStopped;
    i ? r.error(o) : s && r.complete();
  }, t.prototype.asObservable = function() {
    var r = new k();
    return r.source = this, r;
  }, t.create = function(r, n) {
    return new W(r, n);
  }, t;
})(k), W = (function(e) {
  h(t, e);
  function t(r, n) {
    var i = e.call(this) || this;
    return i.destination = r, i.source = n, i;
  }
  return t.prototype.next = function(r) {
    var n, i;
    (i = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || i === void 0 || i.call(n, r);
  }, t.prototype.error = function(r) {
    var n, i;
    (i = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || i === void 0 || i.call(n, r);
  }, t.prototype.complete = function() {
    var r, n;
    (n = (r = this.destination) === null || r === void 0 ? void 0 : r.complete) === null || n === void 0 || n.call(r);
  }, t.prototype._subscribe = function(r) {
    var n, i;
    return (i = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(r)) !== null && i !== void 0 ? i : F;
  }, t;
})(R), z = {
  now: function() {
    return (z.delegate || Date).now();
  },
  delegate: void 0
}, ir = (function(e) {
  h(t, e);
  function t(r, n, i) {
    r === void 0 && (r = 1 / 0), n === void 0 && (n = 1 / 0), i === void 0 && (i = z);
    var o = e.call(this) || this;
    return o._bufferSize = r, o._windowTime = n, o._timestampProvider = i, o._buffer = [], o._infiniteTimeWindow = !0, o._infiniteTimeWindow = n === 1 / 0, o._bufferSize = Math.max(1, r), o._windowTime = Math.max(1, n), o;
  }
  return t.prototype.next = function(r) {
    var n = this, i = n.isStopped, o = n._buffer, s = n._infiniteTimeWindow, u = n._timestampProvider, c = n._windowTime;
    i || (o.push(r), !s && o.push(u.now() + c)), this._trimBuffer(), e.prototype.next.call(this, r);
  }, t.prototype._subscribe = function(r) {
    this._throwIfClosed(), this._trimBuffer();
    for (var n = this._innerSubscribe(r), i = this, o = i._infiniteTimeWindow, s = i._buffer, u = s.slice(), c = 0; c < u.length && !r.closed; c += o ? 1 : 2)
      r.next(u[c]);
    return this._checkFinalizedStatuses(r), n;
  }, t.prototype._trimBuffer = function() {
    var r = this, n = r._bufferSize, i = r._timestampProvider, o = r._buffer, s = r._infiniteTimeWindow, u = (s ? 1 : 2) * n;
    if (n < 1 / 0 && u < o.length && o.splice(0, o.length - u), !s) {
      for (var c = i.now(), a = 0, f = 1; f < o.length && o[f] <= c; f += 2)
        a = f;
      a && o.splice(0, a + 1);
    }
  }, t;
})(R);
function or(e, t) {
  return rr(function(r, n) {
    var i = 0;
    r.subscribe(tr(n, function(o) {
      return e.call(t, o, i++) && n.next(o);
    }));
  });
}
let b, T;
async function ur(e, t) {
  if (!e || !t)
    throw new Error("No wss url or token passed through!");
  const r = `${e}?token=${t}`;
  return T = new ir(1), b = new $(r, {
    onMessage: (n) => {
      T.next(n);
    }
  }), await b.connect();
}
function cr(e) {
  if (!b?.isOpen) {
    console.log(`Socket not open, cannot subscribe to channel: ${e.channel}`);
    return;
  }
  return T.pipe(
    or((t) => {
      let r = {};
      try {
        if (t === "Not Found")
          return !1;
        r = JSON.parse(t);
        const n = r.channel === e.channel && r.view === e.view && e.topic.includes(r.topic);
        return e.subject ? n && r.subject === e.subject : n;
      } catch (n) {
        throw new Error(`Error parsing JSON from WS message: ${{ cause: { err: n, options: e, wsMessage: r } }}`);
      }
    })
  );
}
function ar(e) {
  if (!b?.isOpen)
    return console.log("socket not open, cannot send message"), null;
  b.sendMessage(e);
}
export {
  ur as connect,
  ar as sendWSMessage,
  b as socketConn,
  cr as socketObservable,
  T as socketSubject
};
